import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import { useProfile } from "../Components/Hooks/UserHooks";
import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = ({ allowedRoles, children }: any) => {
  const dispatch: any = useDispatch();

  const { userProfile, loading } = useProfile();
  const { authData, authLoading } = useSelector(
    (state: any) => state.Dashboard
  );

  const userRole = authData?.userRoleType || "Partner";

  useEffect(() => {
    if (userProfile && !loading) {
      setAuthorization(userProfile);
    } else if (!userProfile && loading) {
      dispatch(logoutUser());
    }
  }, [userProfile, loading, dispatch]);

  // Redirect to login if user is not authenticated
  if (!userProfile) {
    return <Navigate to="/login" />;
  }

  // Check if the user has access to the route based on role
  if (authData.$id && allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};

export default AuthProtected;
